import { render } from "./job_list.vue?vue&type=template&id=39f880e5"
import script from "./job_list.vue?vue&type=script&lang=js"
export * from "./job_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__